module.exports = __webpack_public_path__ + "static/media/Hero_Image_Tablet_8.b0e41788.jpg";